export default __webpack_public_path__ + "images/beaf828484ae3f176167db0224bf87b3-caring_for_yourself.svg";